<template>
  <div class="grid">
    <div class="col-12">
      <div v-if="this.detalleOperacion" class="card card-w-title">
        <h1>
          {{ $t("operacion.detalleOperacion.ficha") }}
          <b> {{ detalleOperacion.token ? detalleOperacion.token : "" }} </b>
          <span>
            <Button
              @click.stop="irAPagoCuentas()"
              v-tooltip.bottom="
                $t('operacion.detalleOperacion.botones.tooltips.aPagosCuenta')
              "
              class="p-button p-button-text transparent"
              icon="pi pi-money-bill"
              iconPos="left"
            />
            <Button
              @click.stop="scrollToElementById('listaReclamaciones')"
              v-tooltip.bottom="
                $t('operacion.detalleOperacion.botones.tooltips.aReclamaciones')
              "
              class="p-button p-button-text transparent"
              icon="pi pi-list"
              iconPos="left"
            />

            <Button
              @click.stop="scrollToElementById('listaDocumentos')"
              v-tooltip.bottom="
                $t(
                  'operacion.detalleOperacion.botones.tooltips.aListaDocumentos'
                )
              "
              class="p-button p-button-text transparent"
              icon="pi pi-file-pdf"
              iconPos="left"
            />

            <Button
              @click.stop="irAUsuarios()"
              v-tooltip.bottom="
                $t(
                  'operacion.detalleOperacion.botones.tooltips.aClienteAcreedorDeudor'
                )
              "
              class="p-button p-button-text transparent"
              icon="pi pi-user"
              iconPos="left"
            />
          </span>
        </h1>
        <div class="grid">
          <div class="col-12">
            <Panel :header="$t('operacion.detalleOperacion.caracteristicas')">
              <div class="grid">
                <div class="lg:col-3 sm:col-12">
                  <p v-if="detalleOperacion.token">
                    <b>{{ $t("operacion.token") }}:</b>
                    {{ detalleOperacion.token }}
                  </p>
                  <p v-if="detalleOperacion.fechaAlta">
                    <b>{{ $t("operacion.fechaAlta") }}:</b>
                    {{ getFormattedDateLong(detalleOperacion.fechaAlta) }}
                  </p>
                  <p v-if="detalleOperacion.fechaPublicacion">
                    <b>{{ $t("operacion.fechaPublicacion") }}:</b>
                    {{
                      getFormattedDateLong(detalleOperacion.fechaPublicacion)
                    }}
                  </p>
                  <p v-if="detalleOperacion.fechaInicio">
                    <b>{{ $t("operacion.fechaInicio") }}:</b>
                    {{ getFormattedDateLong(detalleOperacion.fechaInicio) }}
                  </p>
                  <p v-if="detalleOperacion.fechaFin">
                    <b>{{ $t("operacion.fechaFin") }}:</b>
                    {{ getFormattedDateLong(detalleOperacion.fechaFin) }}
                  </p>
                  <p
                    v-if="
                      detalleOperacion.origenDeuda &&
                      this.selectedOrigin &&
                      this.selectedOrigin.code != ''
                    "
                    :key="this.selectedOrigin.code"
                  >
                    <b
                      >{{ $t("reclamacion.detalleReclamacion.origenAbbr") }}:</b
                    >
                    {{ this.selectedOrigin.name }}
                    <Button
                      v-if="permitirEditarOrigenDeuda"
                      @click.stop="modalEditarOrigenDeuda()"
                      :label="$t('common.buttons.edit')"
                      class="p-button p-button-icon-only p-button-text"
                      icon="pi pi-pencil"
                      iconPos="left"
                    />
                  </p>
                  <p
                    v-if="
                      detalleOperacion.fuente &&
                      detalleOperacion.literalFuente &&
                      detalleOperacion.literalFuente.valor !== ''
                    "
                  >
                    <b>{{ $t("operacion.detalleOperacion.fuente") }}:</b>
                    {{ detalleOperacion.literalFuente.valor }}
                  </p>
                  <p
                    v-if="
                      detalleOperacion.producto &&
                      detalleOperacion.producto.contrato
                    "
                  >
                    <b>{{ $t("operacion.tipoContrato") }}:</b>
                    {{ detalleOperacion.producto.contrato.literalTipo.valor }}
                  </p>
                  <p v-if="detalleOperacion.referenciaCliente">
                    <b>{{ $t("operacion.referenciaCliente") }}:</b>
                    {{ detalleOperacion.referenciaCliente }}
                  </p>
                </div>
                <div class="lg:col-5 sm:col-12">
                  <p v-show="detalleOperacion.fechaPublicacion">
                    <b
                      >{{
                        $t("operacion.detalleOperacion.fechaPublicacion")
                      }}:</b
                    >
                    {{
                      getFormattedDateLong(detalleOperacion.fechaPublicacion)
                    }}
                  </p>
                  <p v-show="detalleOperacion.fechaSuspension">
                    <b
                      >{{
                        $t("operacion.detalleOperacion.fechaSuspension")
                      }}:</b
                    >
                    {{ getFormattedDateLong(detalleOperacion.fechaSuspension) }}
                  </p>
                  <p
                    v-if="
                      detalleOperacion.motivoSuspension &&
                      detalleOperacion.literalMotivoSuspension &&
                      detalleOperacion.literalMotivoSuspension.valor !== '' &&
                      detalleOperacion.estado == this.ESTADOS.SUSPENDIDA
                    "
                  >
                    <b
                      >{{
                        $t("operacion.detalleOperacion.motivoSuspension")
                      }}:</b
                    >
                    {{ detalleOperacion.literalMotivoSuspension.valor }}
                  </p>
                  <p
                    v-if="
                      detalleOperacion.motivoCancelacion &&
                      detalleOperacion.literalMotivoCancelacion &&
                      detalleOperacion.literalMotivoCancelacion.valor !== '' &&
                      detalleOperacion.estado == this.ESTADOS.CANCELADA
                    "
                  >
                    <b
                      >{{
                        $t("operacion.detalleOperacion.motivoCancelacion")
                      }}:</b
                    >
                    {{ detalleOperacion.literalMotivoCancelacion.valor }}
                  </p>
                  <BotoneraAccionesOperacion
                    :key="
                      detalleOperacion.tramitadorUuid +
                      '_' +
                      Object.keys(accionesPosibles).length
                    "
                    :tramitadorUuid="detalleOperacion.tramitadorUuid"
                    :accionesPosibles="accionesPosibles"
                    :uuidOperacion="detalleOperacion.uuid"
                    :totalPendiente="detalleOperacion.totalDeudaPendiente"
                    :divisa="detalleOperacion.divisa"
                    :esBotoneraPequenia="false"
                    @clickedAction="processAction"
                  />
                </div>
                <div class="lg:col-4 sm:col-12">
                  <div class="grid">
                    <div class="col-6">
                      <div
                        v-if="
                          detalleOperacion.envioRequerimiento &&
                          detalleOperacion.envioRequerimiento.servicioProveedor
                        "
                      >
                        <h3>{{ $t("operacion.envioRequerimiento") }}</h3>
                        <p>
                          <b>{{ $t("operacion.proveedor") }}:</b>
                          {{
                            detalleOperacion.envioRequerimiento
                              .servicioProveedor
                          }}
                        </p>
                        <p>
                          <b>{{ $t("operacion.tipoEnvio") }}:</b>
                          {{
                            detalleOperacion.envioRequerimiento.literalCodigo
                          }}
                        </p>
                      </div>
                    </div>
                    <div class="col-6">
                      <div
                        v-if="
                          detalleOperacion.envioInclusion &&
                          detalleOperacion.envioInclusion.servicioProveedor
                        "
                      >
                        <h3>{{ $t("operacion.envioInclusion") }}</h3>
                        <p>
                          <b>{{ $t("operacion.proveedor") }}:</b>
                          {{
                            detalleOperacion.envioInclusion.servicioProveedor
                          }}
                        </p>
                        <p>
                          <b>{{ $t("operacion.tipoEnvio") }}:</b>
                          {{ detalleOperacion.envioInclusion.literalCodigo }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Panel>
          </div>
        </div>
        <div class="grid mb-2">
          <div class="col-12 dashboard">
            <Panel
              v-if="detalleOperacion.segmento && detalleOperacion.jsonSegmento !== '{}'"
              :header="$t('operacion.detalleOperacion.segmento') + detalleOperacion.segmento.nombre"
              class="pt-2">
              <ListaAtributos
                :jsonSegmento="detalleOperacion.jsonSegmento"
                :key="'ListaAtributos'"
                id="listaAtributos"
              />
            </Panel>
          </div>
        </div>
        <ListadoPagosCuenta
          :operacionToken="detalleOperacion.token"
          ref="pagosACuenta"
          :idOperacion="detalleOperacion.id"
          :header="$t('reclamacion.dataTables.headerDocumentos')"
          :key="'ListadoPagosCuenta'"
          v-on:actulizar-importes="actulizarImportes()"
          id="listadoPagosCuenta"
          v-if="cliente"
        />
        <ListadoImpagosOperacion
          ref="listadoImpagosOperacion"
          :impagos="detalleOperacion.listaImpagos"
          @on-action-processed="onImpagoActionProcessed"
        />

        <ListadoDocumentos
          :tipo="tipoFicheroOperacionDocs"
          :clave="detalleOperacion.token"
          :header="$t('reclamacion.dataTables.headerDocumentos')"
          :queryAltaFichero="querySubirDocumento"
          :key="'ListaDocumentos'"
          id="listaDocumentos"
        />

        <ListaDocumentosEnvioOperacion
          :claims="detalleOperacion.reclamaciones"
        />

        <ListaMensajesOperacion :claims="detalleOperacion.reclamaciones" />

        <DatosClienteAcreedorDeudor :detalleOperacion="detalleOperacion" />
      </div>
    </div>
  </div>
</template>
<script>
import DatesMixin from "@/utils/dates";
import CurrencyMixin from "@/utils/currency";
import ReclamacionMixin from "@/utils/reclamacion";
import StringsMixin from "@/utils/strings";
import JavascriptMixin from "@/utils/javascript";
import IbanMixin from "@/utils/iban";
import AbilitiesMixin from "@/utils/ability";
import MessagesMixin from "@/utils/messages";

import BotoneraAccionesOperacion from "@/components/portal-gran-cliente/Expedientes/BotoneraAccionesOperacion.vue";
import ListadoPagosCuenta from "@/components/portal-gran-cliente/Expedientes/ListadoPagosCuenta.vue";
import ListadoDocumentos from "@/components/utilidades/ListadoDocumentos.vue";
import DatosClienteAcreedorDeudor from "@/components/portal-gran-cliente/Expedientes/DatosClienteAcreedorDeudor.vue";
import ListadoImpagosOperacion from "@/components/portal-gran-cliente/Expedientes/ListadoImpagosOperacion.vue";
import ListaDocumentosEnvioOperacion from "@/components/portal-gran-cliente/Expedientes/ListaDocumentosEnvioOperacion.vue";
import ListaMensajesOperacion from "@/components/portal-gran-cliente/Expedientes/ListaMensajesOperacion.vue";

import ListaAtributos from "@/components/portal-gran-cliente/altaOperacion/Segmentos/ListaAtributos.vue";

import {
  QUERY_DETALLE_OPERACION,
  UPLOAD_DOCUMENTO_OPERACION,
  QUERY_FLAG_TRANSICIONES_OPERACION,
} from "@/graphQLQueries/OperacionQueries";
import { TIPOS_FICHEROS } from "@/resources/constants";

export default {
  mixins: [
    DatesMixin,
    CurrencyMixin,
    ReclamacionMixin,
    StringsMixin,
    JavascriptMixin,
    IbanMixin,
    AbilitiesMixin,
    MessagesMixin,
  ],
  components: {
    BotoneraAccionesOperacion: BotoneraAccionesOperacion,
    ListadoPagosCuenta: ListadoPagosCuenta,
    ListadoDocumentos: ListadoDocumentos,
    DatosClienteAcreedorDeudor: DatosClienteAcreedorDeudor,
    ListadoImpagosOperacion: ListadoImpagosOperacion,
    ListaDocumentosEnvioOperacion: ListaDocumentosEnvioOperacion,
    ListaMensajesOperacion: ListaMensajesOperacion,
    ListaAtributos: ListaAtributos,
  },
  data() {
    return {
      detalleOperacion: {},
      accionesPosibles: {},
      codigoProducto: null,
      cliente: null,
      skipQuery: true,
      displayEditarAcreedor: false,
      displayEditarDeudor: false,
      permitirEditarUsuario: false,
      permitirDetalleCliente: false,
      permitirEditarOrigenDeuda: false,
      idOperacion: null,
      dropdownOrigins: [],
      selectedOrigin: {},
      displaydialogEditarOrigenDeuda: false,
      errorsFieldsEditarOrigenDeuda: [],
      actionApplied: "",
      activeUsuarios: false,
      actualizar: 0,
      tipoFicheroOperacionDocs: TIPOS_FICHEROS.OPERACION_DOCUMENTOS,
      querySubirDocumento: UPLOAD_DOCUMENTO_OPERACION,
      loading: false,
    };
  },
  created() {
    this.idOperacion = this.$route.params.uuid;
    this.skipQuery = false;
  },
  apollo: {
    detalleOperacion: {
      query: QUERY_DETALLE_OPERACION,
      variables() {
        return {
          uuid: this.idOperacion,
          idioma: this.$i18n.locale,
        };
      },
      update(data) {
        this.$refs.listadoImpagosOperacion.loading = false;
        this.cliente = data.operacion
          ? data.operacion.producto.contrato.cliente
          : null;
        this.dropdownOrigins = data.listadoOrigenesDeuda.map((origen) => {
          return {
            name: origen.valor,
            code: origen.clave,
          };
        });
        this.selectedOrigin = {
          name: data.operacion.literalOrigenDeudaDetalle.valor,
          code: data.operacion.literalOrigenDeudaDetalle.clave,
        };
        return data.operacion;
      },
      skip() {
        return this.skipQuery;
      },
    },
    flagTransiciones: {
      query: QUERY_FLAG_TRANSICIONES_OPERACION,
      variables() {
        return {
          operacionUuid: this.idOperacion,
        };
      },
      update(data) {
        var t = data.flagTransiciones;
        this.accionesPosibles = {
          CANCELADA: t.flagCancelable,
          SUSPENDIDA: t.flagSuspendible,
          RECUPERADA: t.flagRecuperable,
          PAGO_PARCIAL_OPERACION: t.flagOrdenPagable,
        };
      },
      skip() {
        return this.skipQuery;
      },
    },
  },
  methods: {
    search() {
      this.$apollo.queries.detalleOperacion.refetch();
      this.$apollo.queries.flagTransiciones.refetch();
    },
    processAction(value) {
      this.search();
      this.actionApplied = value;
    },
    onImpagoActionProcessed() {
      this.search();
    },
    actulizarImportes() {
      this.actualizar++;
    },
  },
  setup() {},
};
</script>
